module.exports = __webpack_public_path__ + "static/media/technogy4.64e45130.png";